export const PROD_SPECS = [
  {
    title: 'Team Pilot',
    subtitle: '$19/user/month',
    features: [
      '10 Report Templates',
      'Dedicated Domain Name',
      'Role Based Access Permission',
      'Standard Report Workflow',
      'Six Months of Data Retention',
    ],
    borderHighlight: false,
    ctaLabel: 'Start a Pilot',
  },
  {
    title: 'Growth',
    subtitle: '$49/user/month',
    features: [
      '25 Report Templates',
      'Dedicated Domain Name',
      'Role Based Access Permission',
      'Standard and Customizable Report Workflow',
      'Two Years of Data Retention',
    ],
    borderHighlight: true,
    ctaLabel: 'Start a Pilot',
  },
  {
    title: 'Enterprise',
    subtitle: 'Custom Pricing',
    features: [
      'Unlimited Report Templates',
      'SSO & Dedicated Domain',
      'Fine-Grained RBAC + Report-Level Permissions',
      'Custom Workflow Design',
      'Unlimited Data Retention',
      'Dedicated Support & SLA',
    ],
    borderHighlight: false,
    contactSales: true,
    ctaLabel: 'Contact Sales',
  },
];
